import { Observable } from "rxjs";
import { forkJoin } from "rxjs";
import { take } from "rxjs/operators";
import {
  BulkAction,
  ModalService,
  DataService,
  I18nService,
} from "@bb-vendure/admin-ui/core";
import {
  DeleteArtistDocument,
  DeleteArtistMutation,
} from "src/generated-gql/graphql";

export const bulkDeleteAction: BulkAction = {
  location: "artist-list",
  label: "artist.delete-selected-artists",
  icon: "trash",
  iconClass: "is-danger",
  requiresPermission: (userPermissions) =>
    userPermissions.includes("DeleteArtist"),
  onClick: ({ injector, selection, hostComponent, clearSelection }) => {
    const translator = injector.get(I18nService);
    const modalService = injector.get(ModalService);
    const dataService = injector.get(DataService);
    modalService
      .dialog({
        title: translator.translate("artist.delete-selected-artists"),
        body: translator.translate("artist.delete-selected-artists-dialog", {
          count: selection.length,
        }),
        buttons: [
          { type: "secondary", label: "Cancel" },
          { type: "primary", label: "Delete", returnValue: selection },
        ],
      })
      .pipe(take(1))
      .subscribe((result) => {
        if (result) {
          const deleteObservables: Observable<DeleteArtistMutation>[] = [];
          for (const item in result) {
            deleteObservables.push(
              dataService.mutate(DeleteArtistDocument, {
                id: result[item].id,
              })
            );
          }
          forkJoin(deleteObservables).subscribe(() => {
            hostComponent.refresh();
            clearSelection();
          });
        }
      });
  },
};
